import { render, staticRenderFns } from "./HardSoftConsonantsPreview.vue?vue&type=template&id=ad3186aa&lang=pug&"
import script from "./HardSoftConsonantsPreview.vue?vue&type=script&lang=js&"
export * from "./HardSoftConsonantsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports